module.exports = __webpack_public_path__ + "media/images/ping/ping_rojo-554ee2837f11b5c4aa3a7f6f477f0615.svg";